// Initialize analytics
declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

export const initAnalytics = (measurementId: string) => {
  // Add Google Analytics script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize gtag
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  gtag('js', new Date());
  gtag('config', measurementId);

  // Track performance metrics
  if ('performance' in window) {
    const performanceMetrics = {
      FCP: 0,
      LCP: 0,
      CLS: 0,
    };

    // First Contentful Paint
    new PerformanceObserver((entryList) => {
      const entries = entryList.getEntries();
      performanceMetrics.FCP = entries[entries.length - 1].startTime;
      gtag('event', 'FCP', { value: performanceMetrics.FCP });
    }).observe({ entryTypes: ['paint'] });

    // Largest Contentful Paint
    new PerformanceObserver((entryList) => {
      const entries = entryList.getEntries();
      performanceMetrics.LCP = entries[entries.length - 1].startTime;
      gtag('event', 'LCP', { value: performanceMetrics.LCP });
    }).observe({ entryTypes: ['largest-contentful-paint'] });

    // Cumulative Layout Shift
    new PerformanceObserver((entryList) => {
      let cls = 0;
      for (const entry of entryList.getEntries()) {
        if (!(entry as any).hadRecentInput) {
          cls += (entry as any).value;
        }
      }
      performanceMetrics.CLS = cls;
      gtag('event', 'CLS', { value: cls });
    }).observe({ entryTypes: ['layout-shift'] });
  }
};